export const LOCALE_AR = 'ar'
export const LOCALE_AZ = 'az'
export const LOCALE_BG = 'bg'
export const LOCALE_BR = 'br'
export const LOCALE_BS = 'bs'
export const LOCALE_CA = 'ca'
export const LOCALE_CN = 'cn'
export const LOCALE_CS = 'cs'
export const LOCALE_DA = 'da'
export const LOCALE_DE = 'de'
export const LOCALE_EL = 'el'
export const LOCALE_EN = 'en'
export const LOCALE_ES = 'es'
export const LOCALE_ET = 'et'
export const LOCALE_FA = 'fa'
export const LOCALE_FI = 'fi'
export const LOCALE_FIL = 'fil'
export const LOCALE_FR = 'fr'
export const LOCALE_HE = 'he'
export const LOCALE_HI = 'hi'
export const LOCALE_HR = 'hr'
export const LOCALE_HU = 'hu'
export const LOCALE_IS = 'is'
export const LOCALE_IT = 'it'
export const LOCALE_JA = 'ja'
export const LOCALE_KA = 'ka'
export const LOCALE_LT = 'lt'
export const LOCALE_LV = 'lv'
export const LOCALE_MK = 'mk'
export const LOCALE_NL = 'nl'
export const LOCALE_NO = 'no'
export const LOCALE_PL = 'pl'
export const LOCALE_PT = 'pt'
export const LOCALE_RO = 'ro'
export const LOCALE_RU = 'ru'
export const LOCALE_SK = 'sk'
export const LOCALE_SL = 'sl'
export const LOCALE_SR = 'sr'
export const LOCALE_SV = 'sv'
export const LOCALE_TH = 'th'
export const LOCALE_TR = 'tr'
export const LOCALE_TW = 'tw'
export const LOCALE_UK = 'uk'

export const DEFAULT_LOCALE = LOCALE_EN

export const availableLocales = [
	LOCALE_AR,
	LOCALE_AZ,
	LOCALE_BG,
	LOCALE_BR,
	LOCALE_BS,
	LOCALE_CA,
	LOCALE_CN,
	LOCALE_CS,
	LOCALE_DA,
	LOCALE_DE,
	LOCALE_EL,
	LOCALE_EN,
	LOCALE_ES,
	LOCALE_ET,
	LOCALE_FA,
	LOCALE_FI,
	LOCALE_FIL,
	LOCALE_FR,
	LOCALE_HE,
	LOCALE_HI,
	LOCALE_HR,
	LOCALE_HU,
	LOCALE_IS,
	LOCALE_IT,
	LOCALE_JA,
	LOCALE_KA,
	LOCALE_LT,
	LOCALE_LV,
	LOCALE_MK,
	LOCALE_NL,
	LOCALE_NO,
	LOCALE_PL,
	LOCALE_PT,
	LOCALE_RO,
	LOCALE_RU,
	LOCALE_SK,
	LOCALE_SL,
	LOCALE_SR,
	LOCALE_SV,
	LOCALE_TH,
	LOCALE_TR,
	LOCALE_TW,
	LOCALE_UK,
] as const
